export interface RenderOptimizationOptions {
  isSampleProcess: boolean;
  showWarnings: boolean;
  blockCount: number;
  isMapSwitch?: boolean;
}

export function shouldDeferHeavyMapWork({
  isSampleProcess,
  showWarnings,
  blockCount,
  isMapSwitch = false,
}: RenderOptimizationOptions): boolean {
  if (isSampleProcess) return true;
  if (!showWarnings) return true;
  if (!isMapSwitch) return false;

  return blockCount >= 80;
}
